export default __webpack_public_path__ + "static/media/b18.50a31d79.png";